import { CSSProperties } from "react";

const styleCpn = `.cls-1{fill: rgba(255, 255, 255, 0)}.cls-2{fill: #3d3d3d}.cls-3{fill: url(#radial-gradient)}.cls-4{fill: url(#radial-gradient-2)}@media (prefers-color-scheme: dark){.cls-2{fill: #ffffff}}`;

const LogoSVG = ({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 455.48 455.48"
      width={100}
      height={100}
      className={`${className}`}
      style={style}
    >
      <defs>
        <style>{styleCpn}</style>
        <radialGradient
          id="radial-gradient"
          cx="81.54"
          cy="180.42"
          r="35.68"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#de93c2" />
          <stop offset="0.47" stopColor="#c958d1" />
          <stop offset="1" stopColor="#8b2bec" />
        </radialGradient>
        <radialGradient
          id="radial-gradient-2"
          cx="121.49"
          cy="255.34"
          r="34.82"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffeb8b" />
          <stop offset="0.47" stopColor="#f7c182" />
          <stop offset="1" stopColor="#fcb76b" />
        </radialGradient>
      </defs>
      <rect className="cls-1" width="455.48" height="455.48" rx="34.98" />
      <path
        className="cls-2"
        d="M43.32,173.47v47.72H27.67V173.47H15.57v-13.8H55.34v13.8Z"
      />
      <path
        className="cls-2"
        d="M194.71,189.46q0,14.16-9.31,23.58T162,222.45a31.7,31.7,0,0,1-23.06-9.29,31,31,0,0,1-9.51-23,30.06,30.06,0,0,1,9.67-22.77,33.81,33.81,0,0,1,42-2.92,28.24,28.24,0,0,1,11.77,15.79H175.33a14.51,14.51,0,0,0-13.51-8,15.64,15.64,0,0,0-12.14,5.28,18.11,18.11,0,0,0-4.61,12.58,19.16,19.16,0,0,0,4.49,13,15.52,15.52,0,0,0,12.34,5.48,16.9,16.9,0,0,0,9.14-2.39,12.51,12.51,0,0,0,5.5-7.51H158.26V186.21h36.37c0,.49.05,1,.08,1.62Z"
      />
      <path
        className="cls-2"
        d="M202.8,221.19V159.67h34.06v13.8H217.81v9.58h18.45v13.79H217.81v10.55h19.05v13.8Z"
      />
      <path
        className="cls-2"
        d="M269.55,173.47v47.72H253.9V173.47H241.8v-13.8h39.77v13.8Z"
      />
      <path
        className="cls-2"
        d="M323.56,221.19V196.6H303.5v24.59H287.84V159.67H303.5V182.8h20.06V159.67h15.66v61.52Z"
      />
      <path
        className="cls-2"
        d="M350.3,221.19V159.67h34.07v13.8H365.31v9.58h18.45v13.79H365.31v10.55h19.06v13.8Z"
      />
      <path
        className="cls-2"
        d="M72.28,295.77H64.6L55.42,256h-.16L46,295.77H31.88L16.06,234.24H32l8.21,40h.16l9-40h12l8.86,40.18h.16l8.37-40.18h2.92a10,10,0,0,1,9.63,12.52l-11.4,43.13A7.9,7.9,0,0,1,72.28,295.77Z"
      />
      <path
        className="cls-2"
        d="M260.37,295.77l-16.75-26.58h-.16v26.58H227.8V234.24h15.66v27.68h.16l17.32-27.68h16.42l-20.31,30.68,21.61,30.85Z"
      />
      <path
        className="cls-2"
        d="M202.87,274.83a16.86,16.86,0,0,0,11.28-6.74,20.21,20.21,0,0,0,4-12.62q0-10.71-7.59-16.8a19.29,19.29,0,0,0-9.05-3.78,36.05,36.05,0,0,0-4.95-.52c-1.24-.09-2.89-.13-5-.13H172.19v61.53h15.06V275.92h.16l14.2,19.85h17.94Zm-6.07-11.18h0a10.32,10.32,0,0,1-10.32-10.32v-8.12H196.8a8.89,8.89,0,0,1,8.89,8.89v.66A8.89,8.89,0,0,1,196.8,263.65Z"
      />
      <path
        className="cls-2"
        d="M424.64,200.25a16.81,16.81,0,0,0,11.28-6.73,20.24,20.24,0,0,0,4-12.63q0-10.71-7.59-16.8a19.28,19.28,0,0,0-9.05-3.77,36,36,0,0,0-4.95-.53q-1.86-.12-5-.12H394v61.52H409V201.35h.16l14.2,19.84h17.94Zm-5.72-11.44H409V181a9.9,9.9,0,0,1,9.9-9.9h0a8.53,8.53,0,0,1,8.53,8.53v.63A8.53,8.53,0,0,1,418.92,188.81Z"
      />
      <path
        className="cls-2"
        d="M154.15,242.28a31.59,31.59,0,0,0-11.27-7.2c-1.88-.8-4.95-2.13-9.2-4.1-5.57-2.57-12-7.86-14.39-13.78a11.26,11.26,0,0,1-.23-7.66c1-3.24,1.71-5.22,2.11-6.36a32.21,32.21,0,0,0,2.48-12.75,30.45,30.45,0,0,0-9.47-22.72,31.52,31.52,0,0,0-22.9-9.18q-16.38,0-25.93,12.62a28.5,28.5,0,0,0-4,6.9A36.19,36.19,0,0,0,59,191.2a29.36,29.36,0,0,0,9.63,22.2,32.58,32.58,0,0,0,9.11,6.2h0l.24.1c.8.36,1.63.68,2.46,1s1.6.56,2.59.88c1.39.44,2.81.8,4.23,1.12A18.49,18.49,0,0,1,100.82,235c1.25,3.93-.51,17.85-1.36,24.44-.18,1.06-.32,2.14-.41,3.23v0h0c-.08,1-.12,2.06-.12,3.11a29.36,29.36,0,0,0,9.63,22.2,33.25,33.25,0,0,0,45.59-.17,32.1,32.1,0,0,0,0-45.53Z"
      />
      <circle className="cls-3" cx="91.65" cy="190.49" r="23.39" />
      <circle className="cls-4" cx="131.36" cy="265.17" r="22.82" />
    </svg>
  );
};

export default LogoSVG;
